'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useButton } from '@react-aria/button';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { TextInput } from '../text-input/text-input.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { Button } from '../button/button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(e);
        for(o = 0; o < c.length; o++)t = c[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, c = Object.keys(e);
    for(o = 0; o < c.length; o++)t = c[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ComboboxInput = renderWithRef('ComboboxInput', null, (i, f)=>{
    let { buttonRef: _, buttonProps: m, inputRef: j, inputProps: y, menuTrigger: O } = useSwanComboboxContext(), { buttonProps: d } = useButton(_object_spread_props(_object_spread({}, m), {
        isDisabled: i.disabled
    }), _), w = assignRefs(f, j), g = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, y, i), {
        onBlur: (e)=>{
            var r, t;
            null === (r = i.onBlur) || void 0 === r || r.call(i, e), null === (t = y.onBlur) || void 0 === t || t.call(y, e);
        },
        className: className(i.className, 'swan-combobox')
    })), { 'aria-label': x } = d, P = _object_without_properties(d, [
        'aria-label'
    ]);
    return P['aria-hidden'] = true, jsxs(Fragment, {
        children: [
            jsx(RenderComp, {
                forwardedRef: w,
                root: TextInput,
                props: _object_spread_props(_object_spread({}, g), {
                    type: 'text'
                })
            }),
            'focus' === O && jsx(Button, _object_spread_props(_object_spread({
                ref: _
            }, P), {
                className: "swan-combobox-button",
                skin: "tertiary",
                children: d['aria-expanded'] ? jsx(Icon, {
                    iconType: "caretUp"
                }) : jsx(Icon, {
                    iconType: "caretDown"
                })
            }))
        ]
    });
});

export { ComboboxInput };
